import { render, staticRenderFns } from "./AddObject.vue?vue&type=template&id=5444b08b&scoped=true&"
import script from "./AddObject.vue?vue&type=script&lang=js&"
export * from "./AddObject.vue?vue&type=script&lang=js&"
import style0 from "./AddObject.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AddObject.vue?vue&type=style&index=1&id=5444b08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444b08b",
  null
  
)

export default component.exports